import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('dashboard');
const GET_DASHBOARD_ITEM = define('GET_DASHBOARD_ITEM', true);
const MARK_AS_SEEN = define('MARK_AS_SEEN', true);

const initialState = {
  isLoading: true,
  data: {},
  processing: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_DASHBOARD_ITEM.PENDING:
      return {
        ...state,
        isLoading: true
      };
    case GET_DASHBOARD_ITEM.RESOLVED:
      return {
        ...state,
        isLoading: false,
        data: action.data
      };
    case MARK_AS_SEEN.PENDING:
      return {
        ...state,
        processing: true
      };
    case MARK_AS_SEEN.RESOLVED:
    case MARK_AS_SEEN.REJECTED:
      return {
        ...state,
        processing: false
      };
    default: return state;
  }
};

export const actions = {
  loadDashboardData: () => ({
    type: GET_DASHBOARD_ITEM,
    promise: api.get('/dashboard'),
    error: 'Unable to load dashboard data'
  }),
  markAsSeenLxImage: id => ({
    type: MARK_AS_SEEN,
    promise: api.post(`/bookings/${id}/admin/lx-image-mark-as-seen`),
    success: 'LX Selfie has been mark as seen',
    error: 'Unable to mark as seen LX Selfie'
  })
};




// WEBPACK FOOTER //
// ./src/ducks/dashboard.js